import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  initialState,
  searchAssignedBijlagen,
} from '../services/searchAssignedBijlagen'

import { useAssignedBijlagenSearchStore } from './useAssignedBijlagenSearchStore'

export { useAssignedBijlagenSearch, queryKey }

const queryKey = 'bijlagen'

const useQueryStore = () => {
  const { query, storeQuery } = useAssignedBijlagenSearchStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useAssignedBijlagenSearch = () => {
  const { onChangeFilters, onReset, query, onChangePage, onChangeSort } =
    useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => searchAssignedBijlagen({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    sort: query.sort,
    initialFilters: initialState.query.filters,
    onChangeFilters,
    onChangeSort,
    onReset,
    onRefresh: refetch,
    onChangePage,
  }
}
